import React from 'react';
import { format } from 'date-fns';
import { de } from 'date-fns/locale';
import './DateSelector.css';

interface DateSelectorProps {
  selectedDate: string;
  availableDates: string[];
  onDateChange: (date: string) => void;
}

const DateSelector: React.FC<DateSelectorProps> = ({
  selectedDate,
  availableDates,
  onDateChange,
}) => {
  const formatDisplayDate = (dateString: string) => {
    try {
      const date = new Date(dateString);
      return format(date, 'dd. MMMM yyyy', { locale: de });
    } catch {
      return dateString;
    }
  };

  const handlePreviousDay = () => {
    const currentIndex = availableDates.indexOf(selectedDate);
    if (currentIndex < availableDates.length - 1) {
      onDateChange(availableDates[currentIndex + 1]);
    }
  };

  const handleNextDay = () => {
    const currentIndex = availableDates.indexOf(selectedDate);
    if (currentIndex > 0) {
      onDateChange(availableDates[currentIndex - 1]);
    }
  };

  const isToday = (dateString: string) => {
    const today = format(new Date(), 'yyyy-MM-dd');
    return dateString === today;
  };

  return (
    <div className="date-selector">
      <button
        className="date-nav-button"
        onClick={handlePreviousDay}
        disabled={availableDates.indexOf(selectedDate) === availableDates.length - 1}
        aria-label="Vorheriger Tag"
      >
        ←
      </button>

      <div className="date-display">
        <span className="date-text">{formatDisplayDate(selectedDate)}</span>
        {isToday(selectedDate) && <span className="today-badge">Heute</span>}
      </div>

      <button
        className="date-nav-button"
        onClick={handleNextDay}
        disabled={availableDates.indexOf(selectedDate) === 0}
        aria-label="Nächster Tag"
      >
        →
      </button>
    </div>
  );
};

export default DateSelector;